/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";
import {
  IWithinRangeIntegerTag,
  WithinRangeInteger
} from "@pagopa/ts-commons/lib/numbers";

// required attributes
const ProblemJsonR = t.interface({});

// optional attributes
const ProblemJsonO = t.partial({
  detail: t.string,

  status: t.union([
    WithinRangeInteger<100, 600, IWithinRangeIntegerTag<100, 600>>(100, 600),
    t.literal(600)
  ]),

  title: t.string
});

export const ProblemJson = t.intersection(
  [ProblemJsonR, ProblemJsonO],
  "ProblemJson"
);

export type ProblemJson = t.TypeOf<typeof ProblemJson>;
